import React from 'react';
import {NavLink, useLocation} from 'react-router-dom';
import HomeIcon from '../Icons/HomeIcon';
import VpnIcon from '../Icons/VpnIcon';
import TaskIcon from '../Icons/TaskIcon';
import '../Footer/Footer.css'
import {observer} from "mobx-react-lite";
import FriendsIcon from "../Icons/FriendsIcon";

export const Footer = observer(() => {
        const location = useLocation()

        const hapticFeedBack = () => {
            if (window.Telegram?.WebApp?.HapticFeedback) {
                window.Telegram.WebApp.HapticFeedback.selectionChanged();
            }
        }

        return (
            <div className='footer'>
                <NavLink to="/" className='footer_nav_bar_item' onClick={() => hapticFeedBack()}>
                    <HomeIcon location={location}/>
                    Home
                </NavLink>

                <NavLink to="/vpn" className='footer_nav_bar_item' onClick={() => hapticFeedBack()}>
                    <VpnIcon/>
                    VPN
                </NavLink>
                <NavLink to="/tasks" className='footer_nav_bar_item' onClick={() => hapticFeedBack()}>
                    <TaskIcon/>
                    Tasks
                </NavLink>
                <NavLink to="/referrals" className='footer_nav_bar_item' onClick={() => hapticFeedBack()}>
                    <FriendsIcon/>
                    Referrals
                </NavLink>
            </div>
        )
    }
)